// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1UwR2","right":"Footer_right__2c0IC","buttons":"Footer_buttons__V4jM_"};